import { createReducer, on } from '@ngrx/store';
import { lessonActions } from '../actions/lesson.actions';
import { Lesson } from '../models';

export interface LessonState {
    loaded: boolean | null;
    loading: boolean | null;
    saving: boolean;
    saved: boolean;
    error: number | null;
    lesson: Lesson | null;
}

export const initialState: LessonState = {
    loaded: null,
    loading: null,
    saving: false,
    saved: false,
    error: null,
    lesson: null,
};

export const lessonReducer = createReducer(
    initialState,
    // Get
    on(lessonActions.getLesson, (state): LessonState => ({
        ...state,
        loading: true,
        loaded: null,
        error: null,
    })),
    on(lessonActions.getLessonSuccess, (state, { payload }): LessonState => ({
        ...state,
        loading: false,
        loaded: true,
        error: null,
        lesson: payload,
    })),
    on(lessonActions.getLessonError, (state, payload): LessonState => ({
        ...state,
        loading: false,
        loaded: false,
        error: payload.code,
    })),
    // Create
    on(lessonActions.createLesson, (state): LessonState => ({
        ...state,
        saving: true,
        saved: false,
    })),
    on(lessonActions.createLessonSuccess, (state, { payload }): LessonState => ({
        ...state,
        saving: false,
        saved: true,
        lesson: payload,
    })),
    on(lessonActions.createLessonError, (state): LessonState => ({
        ...state,
        saving: false,
        saved: false,
    })),
    // Update
    on(lessonActions.updateLesson, (state): LessonState => ({
        ...state,
        saving: true,
        saved: false,
    })),
    on(lessonActions.updateLessonSuccess, (state, { payload }): LessonState => ({
        ...state,
        saving: false,
        saved: true,
        lesson: payload,
    })),
    on(lessonActions.updateLessonError, (state): LessonState => ({
        ...state,
        saving: false,
        saved: false,
    })),
    // Delete
    on(lessonActions.deleteLesson, (state): LessonState => ({
        ...state,
        saving: true,
        saved: false,
    })),
    on(lessonActions.deleteLessonSuccess, (state): LessonState => ({
        ...state,
        saving: false,
        saved: true,
        lesson: null,
    })),
    on(lessonActions.deleteLessonError, (state): LessonState => ({
        ...state,
        saving: false,
        saved: false,
    })),
    // Clear
    on(lessonActions.clear, (): LessonState => ({ ...initialState })),
);
